import request from 'src/utils/request';
// import { response } from 'express'

export const getUsers = (params: any) =>
  request({
    url: '/users',
    method: 'get',
    params,
  }).then(response => response.data);

export const getUserInfo = (data: any) =>
  request({
    url: '/users/info',
    method: 'post',
    data,
  }).then(response => response.data);

export const getUserByName = (username: string) =>
  request({
    url: `/users/${username}`,
    method: 'get',
  }).then(response => response.data);

export const updateUser = (username: string, data: any) =>
  request({
    url: `/users/${username}`,
    method: 'put',
    data,
  }).then(response => response.data);

export const deleteUser = (username: string) =>
  request({
    url: `/users/${username}`,
    method: 'delete',
  }).then(response => response.data);

export const login = (data: any) => {
  return request
    .post('/api/auth/login', data)
    .then(response => {
      return response;
    })
    .catch(error => {
      throw error;
    });
};

export const logout = (data: { refreshToken: string }) =>
  request
    .post('/api/auth/logout', data)
    .then(response => response);

export const refreshToken = (data: { refreshToken: string }) =>
  request
    .post('/api/auth/refresh', data)
    .then(response => response);

export const register = (data: any) =>
  request({
    url: '/users/register',
    method: 'post',
    data,
  }).then(response => response.data);

// password validation
export interface PasswordValidationRequest {
  password: string;
}

export interface PasswordValidationResponse {
  isValid: boolean;
  errors?: string[] | null;
  warnings?: string[] | null;
  minLength: number;
  requireUppercase: boolean;
  requireLowercase: boolean;
  requireDigit: boolean;
  requireSpecialCharacter: boolean;
}

export const validatePassword = (data: PasswordValidationRequest) =>
  request({
    url: '/api/auth/validate-password',
    method: 'post',
    data,
  }).then(response => response.data?.data || response.data);
